<div [arcErrorTooltip]="_formControl" [class.arc-mde-editor-error]="_formControl?.invalid && _formControl.touched">
    <textarea #arcMarkdownEditor></textarea>
</div>
